import React from 'react';

// Empty-state mark for Reports: a gradient folder inside the shared gradient-
// bordered tile. Rendered at its native 80px (drawn in an 80x80 viewBox); the frame
// is part of the artwork. Gradient ids are per-instance (useId) so multiple copies
// on a page don't collide.
const NoReportsIcon = ({ size = 80 }) => {
  const uid = React.useId();
  const g = (n) => `no_reports_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="79" height="79" rx="11.5" stroke={`url(#${g(0)})`} />
      <path
        d="M20 26H33.8462L37.6923 30.9737H60V53H20V26Z"
        stroke={`url(#${g(1)})`}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id={g(0)} x1="40" y1="0" x2="40" y2="80" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7853F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(1)} x1="10" y1="32.75" x2="35.0408" y2="69.8475" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NoReportsIcon;
